module.exports = __webpack_public_path__ + "static/media/verhuren_hero--bg.9ff8f66d.jpg";